//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Notas from '@/api/promotores/usuarios/notas.api'
import NotaDialog from './NotaDialog'
import groupBy from 'lodash/groupBy'
import moment from "moment"

export default {
	data() {
		return {
			notas: [],
			loading: false
		}
	},

	computed: {
		grupos() {
			return groupBy(this.notas, (nota) => moment(nota.created_at).format('YYYY-MM'))
		}
	},

	mounted() {
		this.loadNotas()
	},

	methods: {
		async loadNotas() {
			try {
				this.loading = true
				this.notas = await Notas.all(this.$route.params.promotor)
			} finally {
				this.loading = false
			}
		},

		openNotaDialog() {
			this.$q.dialog({
				component: NotaDialog,
				promotor: this.$route.params.promotor
			})

			.onOk((nota) => {
				console.log('Nueva nota', nota)
				
				this.notas.unshift(nota);
			})
		}
	}
}
